import { memo, useCallback } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { useDeleteStore } from 'modules/inventory/warehouse/hooks/useDeleteStore';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { useNavigate } from 'react-router';
import { DELETE_WAREHOUSE_ERRORS } from '../../constants/warehouse.errors';

type UserStatusProps = {
  rowId: string;
};

const StoreRowActions = ({ rowId }: UserStatusProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const navigate = useNavigate();
  const { mutate, isPending, error, reset } = useDeleteStore(rowId, onClose);

  const goTo = useCallback(() => {
    navigate(`/inventory/warehouses/${rowId}/general/?edit=true`);
  }, [rowId, navigate]);

  const handleClose = useCallback(() => {
    onClose?.();
    reset();
  }, [onClose, reset]);

  return (
    <>
      <Stack direction='row' spacing={1}>
        <EditRowActions onClick={goTo} />
        <DeleteRowAction
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={handleClose}
          error={error}
          isLoading={isPending}
          onDelete={mutate}
          errors={DELETE_WAREHOUSE_ERRORS}
        />
      </Stack>
    </>
  );
};

export default memo(StoreRowActions);
